import { OrganizationType } from 'src/interfaces/organizations';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { IReviewFilters } from '../../interfaces/reviews';
import { loadFilters } from '../../services/reviews';

export interface ISpecificProducts {
  name: string;
  id: string;
}

interface IState {
  serverFilters: {
    [key in OrganizationType]?: IReviewFilters;
  };
  productsTags: {
    [key in OrganizationType]?: string[];
  };
  loading: boolean;
  loadingError: any;
}

const initialState: IState = {
  serverFilters: {
    [OrganizationType.BANK]: {} as IReviewFilters,
    [OrganizationType.INSURANCE]: {} as IReviewFilters,
    [OrganizationType.MFO]: {} as IReviewFilters,
    [OrganizationType.BROKER]: {} as IReviewFilters,
  },
  productsTags: {
    [OrganizationType.BANK]: [],
    [OrganizationType.INSURANCE]: [],
    [OrganizationType.MFO]: [],
    [OrganizationType.BROKER]: [],
  },
  loading: false,
  loadingError: null,
};

const name = 'filters';

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setAllReviewsFilter(state, { payload }) {
      state.serverFilters = {
        ...state.serverFilters,
        ...payload.allFilters,
      };
      state.productsTags = {
        ...state.productsTags,
        ...payload.allProducts,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewsFilters.fulfilled, (state, { payload }) => {
        state.serverFilters[payload.objectType] = payload.filters;
        state.productsTags[payload.objectType] = payload.products;
        state.loading = false;
      })
      .addCase(fetchReviewsFilters.pending, (state) => {
        state.loading = true;
        state.loadingError = null;
      })
      .addCase(fetchReviewsFilters.rejected, (state, { error }) => {
        state.loading = true;
        state.loadingError = error;
      });
  },
});

export const fetchReviewsFilters = createAsyncThunk<
  { filters: IReviewFilters; products: string[]; objectType: OrganizationType },
  { objectType: OrganizationType; isLegal?: boolean }
>(`${name}/fetchReviewsFilters`, async (payload) => {
  const { objectType, isLegal } = payload;

  const filters = await loadFilters({ objectType, isLegal });
  const products = filters?.tag.reduce((output, item) => {
    return [...output, item.alias];
  }, []);

  return { filters, products, objectType };
});

const { reducer, actions } = slice;

export const { setAllReviewsFilter } = actions;

export default reducer;
